import * as React from 'react'
import * as Modal from 'react-modal'

import {
  Text,
  InlineChildren,
  Inset,
  StackChildren,
} from '@doordash/design-language'

import { Spin } from './styles'

import t from './strings'

const customStyles = {
  overlay: {
    zIndex: 10000,
    backgroundColor: 'rgba(25, 25, 25, 0.75)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '350px',
    minHeight: '170px',
  },
}

const settings = {
  STATIC_URL: 'https://cdn.doordash.com/static/',
}

type LoadingBoxParams = {
  message?: string
}

const LoadingBox: React.SFC<LoadingBoxParams> = ({ message }) => (
  <Modal isOpen style={customStyles}>
    <Inset size={Inset.Sizes.XxLarge}>
      <StackChildren>
        <InlineChildren justifyContent={InlineChildren.Justification.Center}>
          <Spin
            src={`${settings.STATIC_URL}img/spinner.png`}
            height="24px"
            alt={t.loading()}
          />
        </InlineChildren>
        <InlineChildren justifyContent={InlineChildren.Justification.Center}>
          <Text
            styles={Text.Styles.Caps16}
            color={Text.Colors.SystemTeal70}
            weight={Text.Weights.Bold}
          >
            {message}
          </Text>
        </InlineChildren>
      </StackChildren>
    </Inset>
  </Modal>
)

LoadingBox.defaultProps = {
  message: t.loading(),
}

export default LoadingBox
